import { NotificationSnackbarOptions } from '@adcl/ngx-material';

export const mobileSnackBarOption: NotificationSnackbarOptions = {
  duration: 3000,
};
